<template>
  <div v-if="value.customFields">
    <div v-for="(field, index) in fieldsComp" :key="index">
      <v-text-field
        :readonly="readonly != null"
        v-if="field.type != 'Combo'"
        :label="field.label"
        :type="getType(field.type)"
        v-model="value.customFields[field.label]"
        clearable
      ></v-text-field>
      <v-select
        :readonly="readonly != null"
        v-else
        :label="field.label"
        :items="field.comboValues"
        v-model="value.customFields[field.label.toLowerCase()]"
      ></v-select>
    </div>

    <div v-for="(group, index) in groupFieldsComp" :key="index">
      <v-list-item-title class="font-weight-medium">{{ group.group }}</v-list-item-title>
      <div v-for="(field, index) in group.fields" :key="index">
        <v-text-field
          :readonly="readonly != null"
          v-if="field.type != 'Combo'"
          class="pl-5"
          :label="field.label"
          :type="getType(field.type)"
          v-model="value.customFields[field.label]"
          clearable
        ></v-text-field>
        <v-select
          :readonly="readonly != null"
          v-else
          :label="field.label"
          :items="field.comboValues"
          v-model="value.customFields[field.label.toLowerCase()]"
        ></v-select>
      </div>
    </div>
  </div>
</template>

<script>
import entityFieldCustomService from "../../../services/entityFieldCustomService";
import entityFieldCustomCombo from "./entityFieldCustomCombo";
export default {
  name: "entity-field-custom-autoform",
  props: ["value", "entity", "readonly"],
  compnents: { entityFieldCustomCombo },
  data() {
    return {
      fields: [],
    };
  },
  watch: {
    async value() {
      await this.getFields();
    },
  },
  computed: {
    fieldsComp() {
      let onlyFields = this.fields.filter((cf) => cf.group == null || cf.group == "");
      let fields = [];
      if (onlyFields.length == 0) return fields;
      else return this.sortBySeq(onlyFields);
    },
    groupFieldsComp() {
      let onlyGroups = this.fields.filter((cf) => cf.group != null && cf.group != "");
      let groups = [];
      if (onlyGroups.length == 0) return groups;
      onlyGroups.forEach((field) => {
        let group = groups.find((g) => g.group == field.group);
        if (group != null) group.fields.push(field);
        else groups.push({ group: field.group, fields: [field] });
      });

      groups.forEach((g) => (g.fields = this.sortBySeq(g.fields)));
      console.log("groups >>> ", groups)
      return groups;
    },
  },
  methods: {
    sortBySeq(array) {
      return array.sort((a, b) => {
        if (a.seq > b.seq) return 1;
        else if (a.seq < b.seq) return -1;
        else return 0;
      });
    },
    async getFields() {
      let res = await entityFieldCustomService.getByEntityName(this.entity);
      if (res.success) this.fields = res.data;
    },

    getType(type) {
      switch (type) {
        case "Text":
          return "text"

        case "Numeric":
          return "number"
      }
    }
  },
  async mounted() {
    await this.getFields();

    console.log("fields >>> ", this.fields)
  },
};
</script>
